import Plan from 'components/pages/pricing/items/Plan';
import { usePersistState } from 'providers/PersistProvider';
import React, { useState } from 'react';

export default function PlansContainer({ isMobile, optionAgreement }) {
	const [currentPlan, setCurrentPlan] = useState({});
	const { array: allPlanSetups } = usePersistState();

	const handleClosePlan = () => {
		setCurrentPlan({});
	};

	const handleOpenPlan = plan => () => {
		setCurrentPlan(plan);
	};

	return (
		<div>
			<div className='grid sm:grid-cols-3-min gap-x-04 xl:gap-x-12 gap-y-60 sm:gap-y-30 items-center justify-center mb-30 sm:mb-0 mt-30'>
				{allPlanSetups?.slice(0, -1).map(plan => (
					<Plan
						key={plan.id}
						isMobile={isMobile}
						isOpen={!isMobile || currentPlan.id === plan.id}
						onOpen={handleOpenPlan(plan)}
						onClose={handleClosePlan}
						plan={plan}
					/>
				))}
			</div>
		</div>
	);
}
